export default "__VITE_ASSET__0MjQ_ph1__"